import Button from '@mui/material/Button';
import type { SxProps } from '@mui/system';
import type { ReactNode } from 'react';

type BaseButtonProps = {
  // eslint-disable-next-line unused-imports/no-unused-vars
  onClick: (...args: any[]) => any;
  label: string | ReactNode;
  variant?: 'contained' | 'outlined' | 'text';
  sxProps?: SxProps;
  disabled?: boolean;
  ariaLabel?: string;
  dataTestId?: string;
};

const BaseButton = ({
  onClick,
  label,
  sxProps = {},
  variant = 'contained',
  disabled = false,
  ariaLabel,
  dataTestId
}: BaseButtonProps) => (
  <Button
    onClick={onClick}
    variant={variant}
    fullWidth
    sx={{
      height: '56px',
      borderRadius: '4px',
      textTransform: 'none',
      fontSize: '18px',
      fontWeight: 500,
      ...sxProps
    }}
    disabled={disabled}
    aria-label={ariaLabel}
    data-testid={dataTestId}
  >
    {label}
  </Button>
);

export default BaseButton;
